import type { IconSvgObject } from './types';

const RowInsertIcon: IconSvgObject = [
  ["path", { d: "M20 3H9C7.89543 3 7 3.89543 7 5V8C7 9.10457 7.89543 10 9 10H20C21.1046 10 22 9.10457 22 8V5C22 3.89543 21.1046 3 20 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 14H9C7.89543 14 7 14.8954 7 16V19C7 20.1046 7.89543 21 9 21H20C21.1046 21 22 20.1046 22 19V16C22 14.8954 21.1046 14 20 14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 9L5 12L2 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RowInsertIcon;
